import { render, staticRenderFns } from "./DesignComponentsDropdown.vue?vue&type=template&id=4d33ce75"
import script from "./DesignComponentsDropdown.vue?vue&type=script&lang=js"
export * from "./DesignComponentsDropdown.vue?vue&type=script&lang=js"
import style0 from "./DesignComponentsDropdown.vue?vue&type=style&index=0&id=4d33ce75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./DesignComponentsDropdown.vue?vue&type=custom&index=0&blockType=i18n&locale=ko"
if (typeof block0 === 'function') block0(component)

export default component.exports